import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Expertise',
  href: '#matters'
}, {
  label: 'Our People',
  href: '#people'
}, {
  label: 'Insights',
  href: '#insights'
}, {
  label: 'Start Online',
  href: '#start-online',
  accent: true
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPastHero, setIsPastHero] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      // Hero is approximately 100vh, switch at 90vh
      setIsPastHero(window.scrollY > window.innerHeight * 0.9);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const textColor = isPastHero ? 'text-tlfc-text' : 'text-white';
  const textSecondaryColor = isPastHero ? 'text-tlfc-text-secondary' : 'text-white/70';
  const logoColor = isPastHero ? 'text-tlfc-text' : 'text-white';
  const logoMutedColor = isPastHero ? 'text-tlfc-muted' : 'text-white/60';
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled && isPastHero ? 'glass shadow-soft border-b border-tlfc-border' : isScrolled ? 'glass-dark border-b border-white/5' : 'bg-transparent'}`} data-id="element-174">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-175">
        <div className="flex items-center justify-between h-18 lg:h-20" data-id="element-176">
          {/* Logo */}
          <a href="#" className="flex items-center gap-1.5 group" aria-label="Tisher Liner FC Law - Home" data-id="element-177">
            <span className={`text-sm lg:text-base font-semibold tracking-wide ${logoColor} transition-colors`} data-id="element-178">
              Tisher Liner
            </span>
            <span className={`text-sm lg:text-base font-light tracking-wide ${logoMutedColor} transition-colors`} data-id="element-179">
              FC Law
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation" data-id="element-180">
            {navItems.map(item => <a key={item.label} href={item.href} className={`text-sm font-medium transition-colors duration-300 ${item.accent ? 'text-tlfc-blue hover:text-tlfc-blue/80' : `${textSecondaryColor} hover:${textColor}`}`} data-id="element-181">
                {item.label}
              </a>)}
          </nav>

          {/* Right Side CTAs */}
          <div className="flex items-center gap-4" data-id="element-182">
            {/* Phone - Desktop */}
            <a href="tel:0386009333" className={`hidden md:flex items-center gap-2 text-sm ${textSecondaryColor} hover:${textColor} transition-colors`} aria-label="Call us at (03) 8600 9333" data-id="element-183">
              <PhoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-184" />
              <span data-id="element-185">(03) 8600 9333</span>
            </a>

            {/* Book a Call Button - Desktop */}
            <a href="#contact" className="hidden lg:inline-flex items-center px-5 py-2.5 bg-tlfc-gold text-white text-sm font-medium rounded-lg hover:bg-tlfc-gold-light transition-colors shadow-sm" data-id="element-186">
              Book a Call
            </a>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`lg:hidden p-2 ${textColor} transition-colors`} aria-expanded={isMobileMenuOpen} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-187">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" aria-hidden="true" data-id="element-188" /> : <MenuIcon className="w-6 h-6" aria-hidden="true" data-id="element-189" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-tlfc-border shadow-lg" data-id="element-190">
          <nav className="max-w-[1400px] mx-auto px-6 py-6" aria-label="Mobile navigation" data-id="element-191">
            <ul className="space-y-1" data-id="element-192">
              {navItems.map(item => <li key={item.label} data-id="element-193">
                  <a href={item.href} onClick={() => setIsMobileMenuOpen(false)} className={`block py-3 text-base font-medium transition-colors ${item.accent ? 'text-tlfc-blue' : 'text-tlfc-text-secondary hover:text-tlfc-text'}`} data-id="element-194">
                    {item.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-6 pt-6 border-t border-tlfc-border space-y-4" data-id="element-195">
              <a href="tel:0386009333" className="flex items-center gap-2 text-tlfc-text-secondary" data-id="element-196">
                <PhoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-197" />
                <span data-id="element-198">(03) 8600 9333</span>
              </a>
              <a href="#contact" className="block w-full text-center px-5 py-3 bg-tlfc-gold text-white font-medium rounded-lg" data-id="element-199">
                Book a Call
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}